<template>
  <div
    class="screen-terms-and-conditions"
    :class="{ 'has-tab-bar': showTabBar }"
  >
    <app-bar title="Algemene voorwaarden" :show-back-button="true" />
    <div class="container">
      <h1>Algemene voorwaarden Inviplay</h1>

      <p>
        Inviplay brengt mensen op een laagdrempelige manier bij elkaar om samen
        te sporten en bewegen. Onderstaande voorwaarden gelden voor iedereen die
        gebruikmaakt van het Inviplay-platform.
      </p>

      <h2>1. Het platform</h2>
      <p>
        Inviplay biedt een platform waarop mensen sportactiviteiten kunnen
        plaatsen, eraan kunnen deelnemen en sportlocaties kunnen boeken.
        Inviplay treedt op als bemiddelaar en is zelf geen partij bij
        overeenkomsten tussen deelnemers en organisatoren of tussen gebruikers
        en externe verhuurpartijen. Klachten over de uitvoering van een
        activiteit of de staat van een sportlocatie dienen gericht te worden aan
        de betreffende organisator of verhuurpartij.
      </p>

      <p class="mt-4">
        Inviplay kan speciale eisen stellen aan het plaatsen van activiteiten
        door commerciële partijen. Als dat voor jou het geval is, stellen we je
        daarvan op de hoogte. Indien je niet aan deze eisen voldoet, kan
        Inviplay je activiteiten en/of je account verwijderen.
      </p>

      <h2>2. Account en profiel</h2>
      <p>
        Je profiel op Inviplay is persoonlijk en niet overdraagbaar. Je staat in
        voor de juistheid van je profielgegevens. Behandel je inloggegevens
        vertrouwelijk; Inviplay is niet verantwoordelijk voor oneigenlijk
        gebruik van je account.
      </p>

      <h2>3. Deelname aan activiteiten</h2>
      <p>
        Door je aan te melden voor een activiteit ga je een overeenkomst aan met
        de organisator van die activiteit. Deelname is op eigen risico. Zorg
        ervoor dat je fysiek in staat bent om deel te nemen en neem bij twijfel
        contact op met je huisarts. Lol hebben in sporten staat voorop — ga
        respectvol om met andere deelnemers en gun bij twijfel de ander de
        winst.
      </p>

      <h2>4. Sportlocaties</h2>
      <p>
        Sportlocaties die je via Inviplay boekt zijn in beheer bij externe
        partijen, zoals verenigingen, gemeenten of sportbedrijven. Hun regels
        gelden onverkort. Je gaat zorgvuldig om met de locatie en aanwezige
        materialen. Na gebruik lever je de locatie op in de staat waarin je deze
        aantrof en berg je gebruikte materialen netjes op. Gebruik geschikte
        sportschoenen en veroorzaak geen overlast. Meld eventuele schade zo
        spoedig mogelijk bij de betreffende verhuurpartij. Bij schade aan de
        locatie of materialen kan de verhuurpartij je aansprakelijk stellen.
      </p>

      <h2>5. Betaling en prijzen</h2>
      <p>
        De vermelde prijs per activiteit is inclusief btw. Eventuele
        transactiekosten worden apart vermeld bij het kiezen van je
        betaalmethode; deze komen voor rekening van de deelnemer en worden bij
        restitutie niet terugbetaald. Je aanmelding is pas definitief na
        ontvangst van de betaling. Zolang de betaling niet is ontvangen, kan de
        beschikbare plek aan een andere deelnemer worden toegewezen. Na
        succesvolle betaling ontvang je een digitale bevestiging.
      </p>

      <p class="mt-4">
        Betalingen worden verwerkt via Online Payment Platform (OPP). Op
        betalingen zijn daarom tevens de
        <a
          class="link"
          target="_blank"
          href="https://onlinepaymentplatform.com/legal/terms-of-use"
        >
          algemene voorwaarden van OPP
        </a>
        van toepassing.
      </p>

      <h2>6. Annulering en restitutie</h2>
      <p>
        Je kunt je aanmelding kosteloos annuleren tot de door de organisator
        ingestelde annuleringstermijn. Indien de organisator geen afwijkende
        termijn heeft ingesteld, geldt een standaardtermijn van 24 uur voor
        aanvang van de activiteit. Bij annulering na het verstrijken van de
        annuleringstermijn of bij niet-verschijnen (no-show) wordt het betaalde
        bedrag niet gerestitueerd, tenzij de organisator anders beslist. Als een
        activiteit door de organisator wordt geannuleerd, ontvang je het
        volledige bedrag terug via de oorspronkelijke betaalmethode, in principe
        binnen 10 werkdagen.
      </p>

      <h2>7. Gedragsregels en communicatie</h2>
      <p>
        Van alle gebruikers wordt respectvol gedrag verwacht, zowel tijdens
        activiteiten als in berichten op het platform. Discriminatie,
        intimidatie en agressie worden niet getolereerd. Inviplay mag berichten
        die onfatsoenlijk of in strijd met de wet zijn verwijderen. De
        organisator heeft het recht om deelnemers die zich niet aan de
        huisregels houden uit een activiteit te verwijderen zonder recht op
        restitutie.
      </p>

      <p class="mt-4">
        Berichten op het platform zijn niet versleuteld en kunnen door andere
        gebruikers worden gelezen. Deel daarom geen informatie die je als
        vertrouwelijk beschouwt.
      </p>

      <h2>8. Aansprakelijkheid</h2>
      <p>
        Inviplay is niet aansprakelijk voor blessures, schade aan eigendommen of
        enig ander verlies dat voortvloeit uit deelname aan activiteiten of het
        gebruik van sportlocaties. De organisator respectievelijk de
        verhuurpartij is verantwoordelijk voor een veilige sportomgeving. Wij
        adviseren deelnemers om een adequate sport- of
        aansprakelijkheidsverzekering af te sluiten.
      </p>

      <h2>9. Privacy</h2>
      <p>
        Je persoonsgegevens worden verwerkt conform onze privacyverklaring en de
        AVG. Je naam en profielfoto zijn zichtbaar voor andere deelnemers en de
        organisator van activiteiten waarvoor je bent aangemeld. We delen je
        gegevens niet met derden voor commerciële doeleinden.
      </p>

      <h2>10. Berichten van Inviplay</h2>
      <p>
        Inviplay kan je berichten sturen over nieuwe mogelijkheden en updates
        van het platform. Je kunt je voor de nieuwsbrief af- en aanmelden bij je
        profielinstellingen.
      </p>

      <h2>11. Accountbeëindiging</h2>
      <p>
        Inviplay kan een account opschorten of verwijderen bij overtreding van
        deze voorwaarden of misbruik van het platform. Eventuele openstaande
        betalingen of tegoeden worden bij beëindiging afgewikkeld conform de op
        dat moment geldende voorwaarden.
      </p>

      <h2>12. Intellectueel eigendom</h2>
      <p>
        Alle content op het Inviplay-platform, waaronder teksten, logo's,
        ontwerpen en software, is eigendom van Inviplay of haar licentiegevers
        en mag niet zonder voorafgaande toestemming worden verveelvoudigd of
        openbaar gemaakt.
      </p>

      <h2>13. Wijzigingen</h2>
      <p>
        Inviplay behoudt zich het recht voor deze voorwaarden en het platform te
        wijzigen. Bij substantiële wijzigingen word je hiervan op de hoogte
        gesteld via e-mail of een melding in de app. Door na een wijziging
        gebruik te blijven maken van het platform ga je akkoord met de
        aangepaste voorwaarden. Omdat er constant aan Inviplay wordt gewerkt,
        kan het platform van tijd tot tijd wijzigen of tijdelijk niet
        beschikbaar zijn.
      </p>

      <h2>14. Toepasselijk recht</h2>
      <p>
        Op deze voorwaarden is Nederlands recht van toepassing. Geschillen
        worden voorgelegd aan de bevoegde rechter in het arrondissement waar
        Inviplay B.V. is gevestigd.
      </p>

      <h2>15. Contact</h2>
      <p>
        Inviplay B.V.
        <br />
        Prinses Beatrixlaan 26
        <br />
        3554 JK Utrecht
        <br />
        <a href="mailto:contact@inviplay.nl">contact@inviplay.nl</a>
      </p>

      <p class="mt-4 text-sm"><em>Datum publicatie: 16/04/2026</em></p>
    </div>
    <tab-bar v-if="showTabBar" selected="profile" />
  </div>
</template>

<script>
import AppBar from '@/components/AppBar'
import TabBar from '@/components/TabBar'

export default {
  name: 'TermsAndConditions',
  components: {
    AppBar,
    TabBar
  },
  data() {
    return {
      showTabBar: this.$route.query.hideTabBar !== 'true'
    }
  }
}
</script>

<style scoped></style>
